import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "breadcrumb-arrow",
  "use": "breadcrumb-arrow-usage",
  "viewBox": "0 0 5 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5 7\" id=\"breadcrumb-arrow\"><path fill-rule=\"evenodd\" d=\"M5 3.296a.584.584 0 01-.25.507L.92 6.486a.585.585 0 01-.67-.958l3.187-2.232L.25 1.063A.585.585 0 11.92.106l3.832 2.682c.17.12.258.314.248.508z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol